import { Navigate, useLocation } from "react-router-dom";
import { hasSession } from "@/lib/auth";

export const RequireAuth = ({ children }) => {
  const location = useLocation();
  if (!hasSession()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};
